const constants = {
  baseURL: "https://web-api.grind.co.uk/v1",
  stripeKey: "pk_live_YmCXA1JkndU5HIF29bVl3WDd",
  googleKey: "AIzaSyDKjvCWFD4Bo9k887D9g62n6iu-tvq93nU",
  bugsnagReleaseStage: "production",
  multipassUrl: "https://grind.co.uk/account/login/multipass/"
};

export default constants;
